import SendIcon from '@mui/icons-material/Send'
import { Box, IconButton, InputAdornment, TextField } from '@mui/material'
import React, { useState } from 'react'

/**
 * ChatInput - Input field for sending chat messages
 *
 * @param {function} onSend - Callback function when message is sent
 * @param {string} placeholder - Placeholder text for input
 * @param {boolean} disabled - Whether input is disabled
 * @param {Object} sx - Additional styles to apply
 */
export default function ChatInput({ onSend, placeholder = 'Type a message...', disabled = false, sx = {} }) {
  const [message, setMessage] = useState('')

  const handleSend = () => {
    if (message.trim() && !disabled) {
      onSend(message.trim())
      setMessage('')
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  return (
    <Box
      sx={{
        p: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        ...sx,
      }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={4}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
        disabled={disabled}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                color="primary"
                onClick={handleSend}
                disabled={!message.trim() || disabled}
                sx={{
                  '&:hover': {
                    bgcolor: 'action.hover',
                  },
                  border: 'none',
                }}
              >
                <SendIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            bgcolor: 'background.default',
          },
        }}
      />
    </Box>
  )
}
